//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import { mapMutations } from 'vuex'
export default {
  name: 'DiagnosticCriteriaofOsteoarthritisofhands',
  data () {
    return {
      form: {
        data1: '0',
        data2: '0',
        data3: '0',
        data4: '0',
        data5: '0'
      },
      hasScore: false,
      disabled: false
    }
  },
  created () {
    this.hideLoad()
  },
  methods: {
    ...mapMutations(['hideLoad'])
  },
  computed: {
    /** 计算公式结果 */
    score () {
      let self = this
      let form = JSON.parse(JSON.stringify(self.form))
      let result = 0
      for (const key in form) {
        if (form.hasOwnProperty(key)) {
          form[key] = Number(form[key])
          result += form[key]
        }
      }
      
      if (form.data1 && result>=4) {
        return '指间关节骨关节炎'
      } else {
        return ''
      }
    }
  }
}



// WEBPACK FOOTER //
// ./src/pages/formulas/RI/DiagnosticCriteriaofOsteoarthritisofhands.vue